import { render, staticRenderFns } from "./MemberList.vue?vue&type=template&id=b65fa1e2"
import script from "./MemberList.vue?vue&type=script&lang=js"
export * from "./MemberList.vue?vue&type=script&lang=js"
import style0 from "./MemberList.vue?vue&type=style&index=0&id=b65fa1e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports